<template>
  <div id="$address-book$" class="role-list bt fb-col-start-start">
    <div
      v-if="!showSelectDetail"
      class="item-flex-1 fb-col-start-start hidden width-full"
    >
      <!-- 部门层级导航 -->
      <common-node-nav
        v-show="(showNode || []).length"
        class="p-0-16"
        :nodeNav="nodeNav"
        ref="nodeNav"
        nodeType="tpId"
        @click="handlerToGoBackTargetNode"
      ></common-node-nav>
      <!-- 全选 -->
      <!-- <div
        v-show="showNode && showNode.length"
        class="bg-FFFFFF p-0-16 p-12-0 fb-start-center font-34 width-full mb-12"
        @click="handlerSelectAll"
      >
        <i
          class="iconfont mr-8 mt-2 font-48"
          :class="compuedIsSelectedAll ? 'c-006AFE' : 'c-171A1D-40'"
          >{{ compuedIsSelectedAll ? '&#xe66e;' : '&#xe66f;' }}</i
        >
        <span class="item-flex-1">全选</span>
      </div> -->
      <div
        v-show="!showNode || !showNode.length"
        class="h-full c-171A1D-56 fb-col-center-center item-flex-1 relative width-full"
      >
        <common-no-data class="common-no-record">
          <div class="no-item"></div>
          <p class="font-28 no-text"
            >未配置角色组，无可通知人员，<br />请在PC端-设置-角色管理中设置。</p
          >
        </common-no-data>
      </div>

      <div
        v-if="showNode && showNode.length"
        class="node-list item-flex-1 font-34 width-full"
      >
        <div v-if="showType === 1" class="">
          <!-- 角色组列表 -->
          <div v-for="node in showNode" :key="node.roleGroupId">
            <div class="fb-start-center h-56 lh-56 pl-16 bg-FFFFFF">
              <span
                class="mr-16"
                :class="[
                  'iconfont font-48',
                  node.isSelected ? 'c-006AFE' : 'c-171A1D-40'
                ]"
                @click="handlerSelect(node)"
              >
                {{ node.isSelected ? '&#xe66e;' : '&#xe66f;' }}
              </span>
              <div
                class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16"
              >
                <div
                  class="item-flex-1 fb fb-cross-center"
                  @click="handlerSelect(node)"
                  ><span
                    :class="[
                      'text-ellipsis inline-block max-w-150',
                      'c-171A1D'
                    ]"
                    >{{ node.roleGroupName }}</span
                  >
                  <span
                    v-if="(node.memberList || []).length"
                    :class="[
                      'ml-8',
                      node.selectedCnt ? 'c-006AFE' : 'c-171A1D-40'
                    ]"
                    >({{ node.selectedCnt }}/{{ node.memberList.length }})</span
                  ></div
                >
                <div class="c-006AFE font-34">
                  <span
                    class="bl-12 pl-9"
                    v-if="node.memberList"
                    @click.stop="handlerShowNext(node)"
                  >
                    <i class="iconfont">&#xe714;</i>下级
                  </span>
                </div>
              </div>
            </div>
          </div>
          <md-anchor
            ><p> 选择角色组，通知人员自动同步角色组成员 </p
            ><p>人员请在PC端-设置-角色管理中设置</p></md-anchor
          >
        </div>
        <!-- 角色成员列表 -->
        <div v-if="showType === 0" class="node-list bg-FFFFFF font-34 p-0-16">
          <div
            v-for="(node, idx) in showNode"
            class="fb fb-cross-center fb-main-start h-56"
            :class="{
              'h-68': node.userDingId,
              bt: idx !== 0,
              'opacity-28': node.disabled
            }"
            :key="node.userDingId"
            @click="handlerSelect(node)"
          >
            <span class="mr-12 mt-2">
              <i
                v-show="!node.isSelected || node.disabled"
                class="iconfont c-171A1D-40 font-48"
                >&#xe66f;</i
              >
              <i
                v-show="node.isSelected && !node.disabled"
                class="iconfont c-006AFE font-48"
                >&#xe66e;</i
              >
            </span>
            <div
              class="mr-12 font-24 h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
            >
              {{ nameLastTwoWords(node.name) }}
            </div>
            <div class="item-flex-1">
              <div
                class="fb fb-col fb-main-center"
                :class="{ 'p-9-0': node.userDingId }"
              >
                <div
                  class="fb fb-main-start fb-cross-center"
                  :class="{ 'mb-4': node.userDingId }"
                >
                  <span class="font-34 pr-5 text-ellipsis max-w-220">{{
                    node.name
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看详情 -->
    <div v-else class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
        <div
          v-for="(selectedRole, key, index) in selectedData"
          :key="`type-${index}`"
          class="mb-12"
        >
          <div v-if="(selectedRole || []).length">
            <p class="lh-28 p-0-16 c-171A1D-40 font-26">
              {{ key === 'selectedGroup' ? '角色组' : '角色' }}
            </p>
            <div
              v-for="(node, idx) in selectedRole"
              :key="`role-${idx}`"
              class="bg-FFFFFF pl-16 fb fb-cross-center w-fullVw"
            >
              <div
                v-if="node.dingName"
                class="mr-12 font-24 h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
              >
                {{ nameLastTwoWords(node.dingName) }}
              </div>
              <div
                class="bg-FFFFFF h-56 fb fb-main-between fb-cross-center item-flex-1"
                :class="{ bt: idx > 0 }"
                @click.stop="clearRole(node)"
              >
                <span class="font-34 pr-5">{{
                  node.roleGroupName || node.dingName
                }}</span>
                <i class="iconfont font-40 c-171A1D-40 mr-16">&#xe670;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="showSelectDetail = false"
          >确定</common-button
        >
      </div>
    </div>
    <div
      v-show="(showNode || []).length && !showSelectDetail"
      class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8 width-full"
    >
      <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
        已选择: {{ computedSelectedText || '0人' }}
        <i v-show="computedSelectedText" class="ml-8 c-006AFE iconfont font-38"
          >&#xe610;</i
        >
      </div>
      <common-button width="80" height="32" @click="handlerToSubmit"
        >确定</common-button
      >
    </div>
  </div>
</template>

<script>
import { commonNodeNav, commonButton } from '@/components/commonAddressBook'
import {
  setLeft,
  removeLeft,
  pushNullUrl,
  nameLastTwoWords,
  deepCopy,
  resultText
} from '@/utils/comUtils'
import API from '@/api'
import { commonNoData } from '@/components'
import { mcConfirm, mcToast, mcSetTitle } from '@/utils/mcSdkUtils'

export default {
  name: 'CustomRoleGroup',
  components: {
    commonNodeNav,
    commonButton,
    commonNoData
  },
  props: {},
  data() {
    return {
      nameLastTwoWords,
      nodeNav: [], // 部门导航条
      wait: 300, // 防抖时间默认为0.3s
      timeout: null,
      showNode: [], // 当前显示节点
      showType: 1, // 当前节点类型 0 叶子节点 1 部门节点

      showSelectDetail: false,
      showConfirm: false,
      clearConfirm: null,
      // 页面所用--一个角色在多个组 不同组独立操作
      selectedDataAll: {
        selectedUser: [],
        selectedGroup: []
      },
      // 最终所选
      selectedData: {},
      treeNodes: []
    }
  },
  computed: {
    selectedGroupIds() {
      return (this.selectedDataAll.selectedGroup || []).map(
        item => item.roleGroupId
      )
    },
    selectedUserIds() {
      return (this.selectedDataAll.selectedUser || []).map(
        item => item.dingUserId
      )
    },
    userInGroup() {
      const _userInGroup = {}
      this.treeNodes.forEach(item => {
        ;(item.memberList || []).forEach(role => {
          _userInGroup[role.userDingId]
            ? _userInGroup[role.userDingId].push(item.roleGroupId)
            : (_userInGroup[role.userDingId] = [item.roleGroupId])
        })
      })
      return _userInGroup
    },
    //  判断当前节点列表是否已全选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      this.showNode.forEach(item => {
        if (!item.isSelected) {
          _isSelectAll = false
        }
      })
      return _isSelectAll
    },
    //  选择结果文本
    computedSelectedText() {
      const { selectedGroup = [], selectedUser = [] } = this.selectedData
      return resultText(selectedGroup, selectedUser)
    }
  },
  watch: {
    // 关键--全局监听勾选 处理各种状态
    selectedDataAll: {
      handler() {
        const { selectedGroup = [], selectedUser = [] } = this.selectedDataAll
        const dingUserSet = {}
        // 树的状态
        this.treeNodes.forEach(node => {
          const { memberList = [] } = node
          let _selectedCnt = 0
          const _groupSelected = !!selectedGroup.find(
            item => item.roleGroupId === node.roleGroupId
          )
          this.$set(node, 'isSelected', _groupSelected)

          memberList.forEach(nd => {
            const _isSelected = !!selectedUser.find(
              item => item.dingUserId === nd.userDingId
            )
            _isSelected && _selectedCnt++
            this.$set(nd, 'isSelected', _isSelected)
            this.$set(nd, 'disabled', _groupSelected)
          })
          this.$set(
            node,
            'selectedCnt',
            _groupSelected ? memberList.length : _selectedCnt
          )
        })
        // 备一份--真实已选
        this.selectedData = deepCopy(this.selectedDataAll)
        this.selectedData.selectedUser = []
        for (let i = 0; i < selectedUser.length; i++) {
          if (!dingUserSet[selectedUser[i].dingUserId]) {
            this.selectedData.selectedUser.push(selectedUser[i])
          }
          dingUserSet[selectedUser[i].dingUserId] = 1
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.title && mcSetTitle(this.title)
    this.init(true)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init(init) {
      this.nodeNav = []
      this.showType = 1
      init && (this.treeNodes = await this.getTreeNode())
      init && this.initSelectedData()
      this.showNode = this.treeNodes
      pushNullUrl()
      setLeft(this.methodSetLeft)
      this.methodUpdateNodeNav({
        tpId: 0,
        name: '角色组'
      })
    },
    async getTreeNode() {
      return new Promise((resolve, reject) => {
        API.getRoleGroupList({
          campusId: this.campusId
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    initSelectedData() {
      const selectedDataInit = deepCopy(this.selectedDataInit)
      const { selectedUser = [] } = selectedDataInit
      const _userInMoreGroup = []
      const _noGroupUser = []
      selectedUser.forEach((item, index) => {
        const _groupIds = this.userInGroup[item.dingUserId] || []
        if (_groupIds.length === 1) {
          item.roleGroupId = _groupIds[0]
        } else if (_groupIds.length > 1) {
          item.roleGroupId = _groupIds[0]
          _groupIds.shift()
          _groupIds.forEach(group => {
            _userInMoreGroup.push({ ...item, roleGroupId: group })
          })
        } else {
          _noGroupUser.unshift(index)
        }
      })
      for (let i = 0; i < _noGroupUser.length; i++) {
        selectedUser.splice(_noGroupUser[i], 1)
      }

      selectedUser.push(..._userInMoreGroup)
      // 初始化---已选角色分散到各个组
      this.selectedDataAll = selectedDataInit
    },
    // 下级
    handlerShowNext(node) {
      if (node.disabled) {
        return false
      }
      this.showType = 0
      this.showNode = node.memberList
      this.methodUpdateNodeNav({
        tpId: 1,
        name: node.roleGroupName
      })
    },
    // 导航栏返回目标节点
    handlerToGoBackTargetNode(_node, _index) {
      this.init()
    },
    // 切换节点全选状态
    handlerSelectAll() {
      if (this.compuedIsSelectedAll) {
        this.showNode.forEach(item => {
          if (item.isSelected) {
            this.handlerSelect(item)
          }
        })
      } else {
        this.showNode.forEach(item => {
          if (!item.isSelected) {
            this.handlerSelect(item)
          }
        })
      }
    },
    //  切换节点勾选状态
    async handlerSelect(node) {
      const {
        selectedGroupIds = [],
        selectedUserIds = [],
        selectedDataAll: { selectedUser = [], selectedGroup = [] }
      } = this
      if (node.isSelected) {
        if (this.showType === 0) {
          if (node.disabled) {
            return false
          }
          // 角色
          const _idx = selectedUserIds.indexOf(node.userDingId)
          selectedUser.splice(_idx, 1)
        } else {
          // 角色组
          const _idx = selectedGroupIds.indexOf(node.roleGroupId)
          _idx > -1 && selectedGroup.splice(_idx, 1)
        }
      } else {
        if (this.showType === 0) {
          if (node.disabled) {
            return false
          }
          selectedUser.push({
            dingUserId: node.userDingId,
            dingName: node.name
          })
        } else {
          const _idx = selectedGroupIds.indexOf(node.roleGroupId)
          _idx < 0 &&
            selectedGroup.push({
              roleGroupId: node.roleGroupId,
              roleGroupName: node.roleGroupName
            })
          const _node = node.memberList
          _node && this.walkNode(_node)
        }
      }
    },
    // 角色组勾选时，需向下遍历去掉子节点
    walkNode(nodes) {
      const {
        selectedDataAll: { selectedUser = [] }
      } = this
      for (let i = 0; i < nodes.length; i++) {
        // 勾选 保留角色组 去掉子集勾选
        const _idx = selectedUser.findIndex((item, index) => {
          return (
            item === nodes[i].userDingId &&
            nodes[i].roleGroupId === item.roleGroupId
          )
        })
        if (_idx > -1) {
          selectedUser.splice(_idx, 1)
        }
      }
    },
    // 提交选择信息
    handlerToSubmit() {
      if (!this.computedSelectedText) {
        return mcToast({ msg: '请选择' })
      }
      setTimeout(() => {
        this.close({
          resultText: this.computedSelectedText,
          ...this.selectedData
        })
      }, 1)
    },
    // 更新导航条
    methodUpdateNodeNav(node, index) {
      if (index !== undefined && index > -1) {
        this.nodeNav = this.nodeNav.slice(0, index + 1)
      } else {
        this.nodeNav.push(node)
      }
    },
    //  退回拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        if (!(this.showNode || []).length) {
          return this.closeOnly()
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(btnIndex => {
            if (btnIndex === 1) {
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 查看已选角色
    handlerViewDetail() {
      if (!this.computedSelectedText) {
        return false
      }

      this.showSelectDetail = true
    },
    // 清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选角色？`,
        onConfirm() {
          that.selectedDataAll = {
            selectedGroup: [],
            selectedUser: []
          }
          that.selectedData = {
            selectedGroup: [],
            selectedUser: []
          }
          that.$nextTick(() => {
            that.showSelectDetail = false
          })
        }
      }).show()
    },
    // 删除角色/组
    clearRole(node) {
      const { selectedUser = [], selectedGroup = [] } = this.selectedData
      if (node.dingUserId) {
        const _index = selectedUser.findIndex(
          item => item.dingUserId === node.dingUserId
        )
        if (_index > -1) {
          selectedUser.splice(_index, 1)
        }
        // 删除树中的勾选
        const _selectedUser = this.selectedDataAll.selectedUser.filter(item => {
          return item.dingUserId !== node.dingUserId
        })
        this.selectedDataAll.selectedUser = _selectedUser
      } else {
        const _index = selectedGroup.findIndex(
          item => item.roleGroupId === node.roleGroupId
        )
        if (_index > -1) {
          selectedGroup.splice(_index, 1)
          // 删除树中的勾选
          this.selectedDataAll.selectedGroup.splice(_index, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.role-list {
  width: 100%;
  height: 100%;
  background: #f2f2f6;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .node-list {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    > div {
      &:last-child {
        border-bottom: none;
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
      .next {
        color: #006afe;
        padding-left: 8px;
        border-left: 1px solid rgba(#171a1d, 0.12);
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
    }
  }

  .footer {
    :deep(.c-button) {
      height: 46px;
      line-height: 46px;
      border-radius: 8px;
    }
  }
}
</style>
